export const data = function() {
  return {
    isDebug: true,
    loading: false,
    communicationID: 0,
    communication: null,
    tabs: [
      { name: 'communicationGeneralInfo', label: 'General Information' },
      { name: 'communicationScheduling', label: 'Scheduling' },
      { name: 'communicationAudiences', label: 'Audiences' },
      { name: 'composeMail', label: 'Compose Mail' },
      { name: 'composeEmail', label: 'Compose Email' },
      { name: 'composeSms', label: 'Compose SMS' },
      { name: 'attachments', label: 'Attachments' },
      { name: 'review', label: 'Review & Deliver' }
    ],
    styles: {
      mainContainer: {
        minHeight: '1000px'
      }
    },
    transitionName: 'slide-down',
    showUploadModal: false
  }
}
